import { render, staticRenderFns } from "./html-render.vue?vue&type=template&id=a9022ae0&"
import script from "./html-render.vue?vue&type=script&lang=js&"
export * from "./html-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports